import { render, staticRenderFns } from "./refundOrderDetail.vue?vue&type=template&id=30a0eb29&scoped=true"
import script from "./refundOrderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./refundOrderDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./refundOrderDetail.vue?vue&type=style&index=0&id=30a0eb29&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a0eb29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30a0eb29')) {
      api.createRecord('30a0eb29', component.options)
    } else {
      api.reload('30a0eb29', component.options)
    }
    module.hot.accept("./refundOrderDetail.vue?vue&type=template&id=30a0eb29&scoped=true", function () {
      api.rerender('30a0eb29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/refundOrderDetail.vue"
export default component.exports